import {
  GET_TAXES_REQUEST,
  GET_TAXES_SUCCESS,
  GET_TAXES_FAILURE,
  CREATE_TAX_REQUEST,
  CREATE_TAX_SUCCESS,
  CREATE_TAX_FAILURE,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TAX_FAILURE,
  DELETE_TAX_REQUEST,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE
} from '../types';

const initialState = {
  taxes: [],
  taxesLoading: false,
  taxesError: null,
  taxesPagination: null,
  
  // General loading and error states
  loading: false,
  error: null,
  success: null
};

const taxReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Taxes
    case GET_TAXES_REQUEST:
      return {
        ...state,
        taxesLoading: true,
        taxesError: null
      };
    case GET_TAXES_SUCCESS:
      return {
        ...state,
        taxesLoading: false,
        taxes: action.payload.data,
        taxesPagination: action.payload.pagination
      };
    case GET_TAXES_FAILURE:
      return {
        ...state,
        taxesLoading: false,
        taxesError: action.payload
      };
      
    // Create Tax
    case CREATE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        taxes: [action.payload.data, ...state.taxes]
      };
    case CREATE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Update Tax
    case UPDATE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        taxes: state.taxes.map(tax =>
          tax.id === action.payload.data.id ? action.payload.data : tax
        )
      };
    case UPDATE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    // Delete Tax
    case DELETE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DELETE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        taxes: state.taxes.filter(tax => tax.id !== action.payload.id)
      };
    case DELETE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    default:
      return state;
  }
};

export default taxReducer;
